export default __webpack_public_path__ + "static/media/paralax2.3cdc2f5a.jpg";